import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";

import { getOrderByID } from "../actions/orderActions";
import "../css/records.css";

const OrderScreen = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(getOrderByID(id));
  }, []);

  const [loading, setLoading] = useState(false);

  const [isMarkedOnOMS, setIsMarkedOnOMS] = useState(false);

  const orderById = useSelector((state) => state.orderById);
  const { order } = orderById;

  const adminLogin = useSelector((state) => state.adminLogin);
  const { admin } = adminLogin;

  const [carrier, setCarrier] = useState("");
  const [docketId, setDocketId] = useState("");

  const adminInfo = useSelector((state) => state.adminInfo);

  const { adminData } = adminInfo;

  useEffect(() => {
    if (order) {
      setIsMarkedOnOMS(order.orderInfo.omsMarked);
      setCarrier(order?.orderInfo?.logistics?.carrier);
      setDocketId(order?.orderInfo?.logistics?.docketId);
    }
  }, [order, dispatch]);

  const currencyFormat = (num) => {
    return "₹" + " " + num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  };

  const getISTTime = (time) => {
    var localTime = new Date(time).toLocaleString(undefined, {
      timeZone: "Asia/Kolkata",
    });
    return localTime;
  };

  const resentEmail = async () => {
    if (window.confirm("Resend Confirmation Email ?")) {
      try {
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${admin.token}`,
          },
        };

        const { data } = await axios.post(
          "/api/order/send-email",
          { order: order.orderInfo },
          config
        );

        if (data) {
          alert("MAIL SENT SUCCESSFULLY");
        }
      } catch (error) {
        alert(error);
      }
    }
  };

  const setTrackingLink = (link) => {
    switch (link) {
      case "Safexpress":
        return "http://www.safexpress.com/Portal/faces/TrackShipment.jspx?_afrLoop=23129212080825529&_afrWindowMode=0&_afrWindowId=1ainbz1l4w&_adf.ctrl-state=1grtuyrup_29#!%40%40%3F_afrWindowMode%3D0%26_afrLoop%3D23129212080825529%26_afrWindowId%3D1ainbz1l4w%26_adf.ctrl-state%3D1grtuyrup_33";

      case "Xpressbees":
        return "https://www.xpressbees.com/track/";

      case "BOX N FREIGHT":
        return "https://boxnfreight.in/";

      case "Delhivery":
        return "https://www.delhivery.com/";

      case "Trackon":
        return "https://trackon.in/Tracking/t2/MultipleTracking";

      default:
        break;
    }
  };

  const AddTrackingDetails = async (e) => {
    e.preventDefault();

    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${admin.token}`,
        },
      };

      const { data } = await axios.post(
        "/api/order/add-tracking",
        {
          id: order.orderInfo._id,
          carrier,
          link: setTrackingLink(carrier),
          docketId,
        },
        config
      );

      if (data) {
        alert("Tracking Details Added Successfully");
        dispatch(getOrderByID(id));
      }
    } catch (error) {
      alert(error);
    }
  };

  const markAsDelivered = async () => {
    if (window.confirm("Do You Want to Mark this Order as Delivered ?")) {
      try {
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${admin.token}`,
          },
        };

        const { data } = await axios.post(
          "/api/order/delivered",
          {
            id: order.orderInfo._id,
          },
          config
        );

        if (data) {
          alert("Order is Marked As Delivered");
          dispatch(getOrderByID(id));
        }
      } catch (error) {
        alert(error);
      }
    }
  };

  const handleToggleOMS = async () => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${admin.token}`,
        },
      };
      const { data } = await axios.patch(
        "/api/order/mark-on-oms",
        {
          order: order.orderInfo,
          createdBy: adminData.name,
        },
        config
      );
      if (data.ok) {
        const newStatus = !isMarkedOnOMS;
        setIsMarkedOnOMS(newStatus);
        alert("OMS Marked Status:", newStatus);
      }
    } catch (error) {
      alert(error.response.data.error);
    }
  };

  return (
    <>
      {/* // TRACKING DETAILS MODAL */}
      <div
        class="modal fade"
        id="trackingModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog  modal-dialog-centered">
          <form className="modal-content" onSubmit={AddTrackingDetails}>
            <div class="">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                  Tracking Details
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <div class="form-floating">
                  <select
                    class="form-select mb-3"
                    value={carrier}
                    required
                    onChange={(e) => setCarrier(e.target.value)}
                    id="floatingSelect"
                    aria-label="Floating label select example"
                  >
                    <option selected disabled></option>
                    <option value="Safexpress">Safexpress</option>
                    <option value="Xpressbees">Xpressbees</option>
                    <option value="BOX N FREIGHT">BOX N FREIGHT</option>
                    <option value="Delhivery">Delhivery</option>
                    <option value="	Trackon">Trackon</option>
                  </select>
                  <label for="">Logistics Partner</label>
                </div>
                <div class="form-floating ">
                  <input
                    type="text"
                    required
                    value={docketId}
                    onChange={(e) => setDocketId(e.target.value)}
                    class="form-control"
                    id="floatingInput"
                    placeholder="name@example.com"
                  />
                  <label for="floatingInput">Docket Number</label>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="submit"
                  class="btn btn-primary"
                  data-bs-dismiss="modal"
                >
                  Save changes
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="container-fluid ps-0 ">
        <div className="row ">
          <div className="col-lg-2">
            <Sidebar active={2} />
          </div>
          <div
            className="col-lg-10 position-relative p-0"
            style={{
              height: "100vh",
              overflowY: "scroll",
            }}
          >
            {order && (
              <>
                {order.orderInfo.test === true && (
                  <h1
                    className="text-danger fw-bold position-absolute"
                    style={{
                      fontSize: "19em",
                      top: "50%",
                      left: "50%",
                      translate: "-50% -50%",
                    }}
                  >
                    TEST
                  </h1>
                )}
                <div className="records-page pb-0">
                  <button
                    onClick={() => navigate(-1)}
                    className="btn btn-outline-dark records-action-btn mb-3"
                  >
                    <i class="fa-solid fa-arrow-left"></i>
                    Back
                  </button>

                  <div className="records-header-row d-flex align-items-center justify-content-between flex-wrap">
                    <div>
                      <span className="d-block text-muted">Ordered on</span>
                      <h4 className="records-heading mb-1">
                        {getISTTime(order.orderInfo.createdAt)}
                      </h4>
                      <span
                        className={`status-badge ${
                          order.orderInfo.orderStatus === "Delivered"
                            ? "active"
                            : "draft"
                        }`}
                      >
                        {order.orderInfo.orderStatus}
                      </span>
                    </div>

                    <div
                      className="d-flex align-items-center flex-wrap"
                      style={{ gap: "0.75em" }}
                    >
                      {order.orderInfo.paymentStatus &&
                        order.orderInfo.orderStatus == "Dispatched" &&
                        adminData.accessLevel === "Master" && (
                          <button
                            onClick={markAsDelivered}
                            className="btn btn-danger text-light records-action-btn"
                          >
                            <i class="fa-solid fa-truck"></i> Mark As
                            Delivered
                          </button>
                        )}
                      {adminData.accessLevel === "Master" &&
                        order.orderInfo.paymentStatus && (
                          <button
                            data-bs-toggle="modal"
                            data-bs-target="#trackingModal"
                            className="btn btn-warning text-light records-action-btn"
                          >
                            <i class="fa-solid fa-location-dot"></i>{" "}
                            {order.orderInfo.orderStatus == "Delivered"
                              ? "View Tracking Details"
                              : "Add Tracking Details"}
                          </button>
                        )}
                      {adminData.accessLevel === "Master" &&
                        order.orderInfo.paymentStatus && (
                          <button
                            onClick={resentEmail}
                            className="btn btn-primary text-light records-action-btn"
                          >
                            <i class="fa-solid fa-envelope"></i> Resend Email
                          </button>
                        )}

                      {adminData.accessLevel === "Master" &&
                        order.orderInfo.paymentStatus && (
                          <button
                            onClick={handleToggleOMS}
                            className={`btn text-light records-action-btn ${
                              isMarkedOnOMS ? "btn-danger" : "btn-success"
                            }`}
                          >
                            <i class="fa-solid fa-arrows-rotate"></i>{" "}
                            {isMarkedOnOMS ? "Unmark on OMS" : "Mark on OMS"}
                          </button>
                        )}

                      <span
                        className={`status-badge ${
                          order.orderInfo.paymentStatus ? "active" : "danger"
                        }`}
                        style={{ fontSize: "0.95em" }}
                      >
                        {order.orderInfo.paymentStatus ? "Paid" : "Unpaid"}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="container-fluid">
                  <div className="row mt-3">
                    <div className="col-12 col-md-7  ">
                      <div className="form-card">
                        <h6 className="mb-2">
                          Order Id:{" "}
                          <span className="ms-3">
                            {" "}
                            EM
                            {String(order.orderInfo._id)
                              .slice(-6)

                              .toUpperCase()}
                          </span>
                        </h6>
                        <hr />
                        <p>
                          name :{" "}
                          <span className="ms-3"> {order.orderInfo.name}</span>
                        </p>
                        <p>
                          email :{" "}
                          <span className="ms-3">{order.orderInfo.email}</span>
                        </p>
                        <p>
                          Phone Number :{" "}
                          <span className="ms-3">
                            {order.orderInfo.phoneNumber}
                          </span>
                        </p>
                        {order.orderInfo.gstin && (
                          <p>
                            GSTIN :{" "}
                            <span className="ms-3">
                              {order.orderInfo.gstin}
                            </span>
                          </p>
                        )}
                      </div>
                      <div className=" mt-4">
                        <div className="form-card">
                          <h6 className="mb-2">Shipping Details:</h6>
                          <hr />
                          <div className="d-flex">
                            <p className="col-2">Address : </p>{" "}
                            <p>
                              {order.orderInfo.address.addressLine1},{" "}
                              {order.orderInfo.address.addressLine2},{" "}
                              {order.orderInfo.address.city},{" "}
                              {order.orderInfo.address.state}.{" "}
                              {order.orderInfo.address.pincode}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex pe-3" style={{ gap: "1rem" }}>
                        <div className="mt-4 col-5 form-card">
                          <h6 className="mb-2">Order Invoice Details:</h6>
                          <hr />
                          <p className="d-flex justify-content-between pe-3">
                            Total Items :{" "}
                            <span className="">
                              {" "}
                              {order.orderInfo.items.reduce(
                                (acc, item) => acc + item.qty,
                                0,
                              )}
                            </span>
                          </p>
                          <p className="d-flex justify-content-between pe-3">
                            Sub Total :{" "}
                            <span className="">
                              {" "}
                              {currencyFormat(
                                order.orderInfo.items.reduce(
                                  (acc, item) => acc + item.price,
                                  0,
                                ),
                              )}
                            </span>
                          </p>
                          {!order.orderInfo.promoCode &&
                            order.orderInfo.amount < 249 && (
                              <p className="d-flex justify-content-between pe-3">
                                Delivery :{" "}
                                <span className="">
                                  {currencyFormat(
                                    order.orderInfo.amount -
                                      order.orderInfo.items.reduce(
                                        (acc, item) => acc + item.price,
                                        0,
                                      ),
                                  )}
                                </span>
                              </p>
                            )}

                          {order.orderInfo.promoCode && (
                            <p className="d-flex justify-content-between pe-3">
                              Promocode :{" "}
                              <span className="">
                                {" "}
                                {order.orderInfo.promoCode}
                              </span>
                            </p>
                          )}

                          {order.orderInfo.promoCode && (
                            <p className="d-flex justify-content-between pe-3">
                              Promocode Value :{" "}
                              <span className="">
                                {" "}
                                {currencyFormat(
                                  order.orderInfo.items.reduce(
                                    (acc, item) => acc + item.price,
                                    0,
                                  ) - order.orderInfo.amount,
                                )}
                              </span>
                            </p>
                          )}

                          <p className="d-flex justify-content-between pe-3">
                            Total Amount
                            <span className="fw-normal">
                              {" "}
                              {currencyFormat(order.orderInfo.amount)}
                            </span>
                          </p>
                        </div>
                        <div className="col-7 mt-4 form-card">
                          <h6 className="mb-2">Payment Details:</h6>
                          <hr />
                          {order.paymentInfo ? (
                            <>
                              <>
                                {order.orderInfo.paymentMethod === "PayU" ? (
                                  <>
                                    <p className="d-flex justify-content-between pe-3">
                                      Payment Method:
                                      <span className="fw-normal">PayU</span>
                                    </p>
                                    <p className="d-flex justify-content-between pe-3">
                                      PayU ID:
                                      <span className="fw-normal">
                                        {order.paymentInfo.payuId}
                                      </span>
                                    </p>
                                    <p className="d-flex justify-content-between pe-3">
                                      Bank Ref No:
                                      <span className="fw-normal">
                                        {order.paymentInfo.bankRefNum}
                                      </span>
                                    </p>
                                    <p className="d-flex justify-content-between pe-3">
                                      Amount Paid:
                                      <span className="fw-normal">
                                        ₹ {order.paymentInfo.amount}
                                      </span>
                                    </p>
                                    <p className="d-flex justify-content-between pe-3">
                                      Status:
                                      <span className="fw-normal">
                                        {order.paymentInfo.status}
                                      </span>
                                    </p>
                                  </>
                                ) : order.orderInfo.paymentMethod ===
                                  "Snapmint" ? (
                                  <>
                                    <p className="d-flex justify-content-between pe-3">
                                      Payment Method:
                                      <span className="fw-normal">
                                        Snapmint
                                      </span>
                                    </p>
                                    <p className="d-flex justify-content-between pe-3">
                                      Snapmint ID:
                                      <span className="fw-normal">
                                        {order.paymentInfo.snapmintId}
                                      </span>
                                    </p>
                                    <p className="d-flex justify-content-between pe-3">
                                      EMI Tenure:
                                      <span className="fw-normal">
                                        {order.paymentInfo.emiTenure}
                                      </span>
                                    </p>
                                    <p className="d-flex justify-content-between pe-3">
                                      EMI Amount:
                                      <span className="fw-normal">
                                        ₹{order.paymentInfo.emiAmount}
                                      </span>
                                    </p>
                                    <p className="d-flex justify-content-between pe-3">
                                      Downpayment:
                                      <span className="fw-normal">
                                        ₹{order.paymentInfo.downPayment}
                                      </span>
                                    </p>
                                  </>
                                ) : order.orderInfo.paymentMethod ===
                                  "SaveIn" ? (
                                  <>
                                    <p className="d-flex justify-content-between pe-3">
                                      Payment Method:
                                      <span className="fw-normal">
                                        SaveIn
                                      </span>
                                    </p>
                                    <p className="d-flex justify-content-between pe-3">
                                      Application ID:
                                      <span className="fw-normal">
                                        {order.paymentInfo.applicationId}
                                      </span>
                                    </p>
                                    <p className="d-flex justify-content-between pe-3">
                                      EMI Tenure:
                                      <span className="fw-normal">
                                        {order.paymentInfo.emiTenure}
                                      </span>
                                    </p>
                                    <p className="d-flex justify-content-between pe-3">
                                      EMI Amount:
                                      <span className="fw-normal">
                                        ₹{order.paymentInfo.emiAmount}
                                      </span>
                                    </p>
                                  </>
                                ) : order.orderInfo.paymentMethod ===
                                  "Bajaj" ? (
                                  <>
                                    <p className="d-flex justify-content-between pe-3">
                                      Payment Method:
                                      <span className="fw-normal">Bajaj</span>
                                    </p>
                                    <p className="d-flex justify-content-between pe-3">
                                      Deal ID:
                                      <span className="fw-normal">
                                        {order.paymentInfo.bajajDealId}
                                      </span>
                                    </p>
                                    <p className="d-flex justify-content-between pe-3">
                                      EMI Tenure:
                                      <span className="fw-normal">
                                        {order.paymentInfo.emiTenure}
                                      </span>
                                    </p>
                                    <p className="d-flex justify-content-between pe-3">
                                      EMI Amount:
                                      <span className="fw-normal">
                                        ₹{order.paymentInfo.emiAmount}
                                      </span>
                                    </p>
                                    <p className="d-flex justify-content-between pe-3">
                                      Loan Amount:
                                      <span className="fw-normal">
                                        ₹{order.paymentInfo.amount}
                                      </span>
                                    </p>
                                  </>
                                ) : (
                                  <>
                                    <p className="d-flex justify-content-between pe-3">
                                      Payment Method:
                                      <span className="fw-normal">
                                        {order.orderInfo.paymentMethod}
                                      </span>
                                    </p>
                                    <p className="d-flex justify-content-between pe-3">
                                      RazorPay Order ID:
                                      <span className="fw-normal">
                                        {order.paymentInfo.order_id}
                                      </span>
                                    </p>
                                    <p className="d-flex justify-content-between pe-3">
                                      RazorPay Payment ID:
                                      <span className="fw-normal">
                                        {order.paymentInfo.id}
                                      </span>
                                    </p>
                                    <p className="d-flex justify-content-between pe-3">
                                      Amount Paid:
                                      <span className="fw-normal">
                                        ₹{" "}
                                        {String(
                                          order.paymentInfo.amount,
                                        ).substring(
                                          0,
                                          String(order.paymentInfo.amount)
                                            .length - 2,
                                        )}
                                      </span>
                                    </p>
                                    <p className="d-flex justify-content-between pe-3">
                                      Status:
                                      <span className="fw-normal">
                                        {order.paymentInfo.status}
                                      </span>
                                    </p>
                                    <p className="d-flex justify-content-between pe-3">
                                      Method:
                                      <span className="fw-normal text-uppercase">
                                        {order.paymentInfo.method}
                                      </span>
                                    </p>
                                  </>
                                )}
                              </>
                            </>
                          ) : (
                            <>
                              <p className="d-flex justify-content-between pe-3">
                                Payment Method:
                                <span className="fw-normal">Razorpay</span>
                              </p>
                              {order.orderInfo.paymentDetails
                                .razorpayOrderId && (
                                <>
                                  <p className="d-flex justify-content-between pe-3">
                                    RazorPay Order ID:
                                    <span className="fw-normal">
                                      {order.paymentOrderInfo.id}
                                    </span>
                                  </p>
                                  <p className="d-flex justify-content-between pe-3">
                                    Amount:
                                    <span className="fw-normal">
                                      ₹{" "}
                                      {String(
                                        order.paymentOrderInfo.amount,
                                      ).substring(
                                        0,
                                        String(order.paymentOrderInfo.amount)
                                          .length - 2,
                                      )}
                                    </span>
                                  </p>
                                  <p className="d-flex justify-content-between pe-3">
                                    Amount Due:
                                    <span className="fw-normal">
                                      ₹{" "}
                                      {String(
                                        order.paymentOrderInfo.amount_due,
                                      ).substring(
                                        0,
                                        String(
                                          order.paymentOrderInfo.amount_due,
                                        ).length - 2,
                                      )}
                                    </span>
                                  </p>
                                  <p className="d-flex justify-content-between pe-3">
                                    Amount Paid:
                                    <span className="fw-normal">
                                      ₹{" "}
                                      {String(
                                        order.paymentOrderInfo.amount_paid,
                                      ).substring(
                                        0,
                                        String(
                                          order.paymentOrderInfo.amount_paid,
                                        ).length - 2,
                                      )}
                                    </span>
                                  </p>
                                  <p className="d-flex justify-content-between pe-3">
                                    Status:
                                    <span className="fw-normal">
                                      {order.paymentOrderInfo.status}
                                    </span>
                                  </p>
                                </>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-5  ">
                      <div className="form-card">
                        <h6 className="mb-2">Items:</h6>
                        <hr />
                        {order.orderInfo.items.map((item, itemIndex) => {
                          // Post-revamp order items use a flat schema
                          // (image, colorName, variantName, lineTotal) while
                          // pre-revamp items nest that data under
                          // cartImages/models/variants keyed by model/color/variant
                          // index. Detect which shape this item is and read
                          // accordingly so both old and new orders render.
                          const isNewItemSchema =
                            item.variantId !== undefined ||
                            item.lineTotal !== undefined;

                          const itemImage = isNewItemSchema
                            ? item.image
                            : item.cartImages &&
                              (item.cartImages[item.model] ||
                                item.cartImages[item.color]);

                          const itemColorName = isNewItemSchema
                            ? item.colorName
                            : item.models &&
                              item.models[item.model] &&
                              item.models[item.model].colorName;

                          const itemVariantName = isNewItemSchema
                            ? item.variantName
                            : item.variant !== "" &&
                              item.variants &&
                              item.variants[item.variant] &&
                              (item.name === "Ray Light" ||
                              item.name === "Beam Light" ||
                              item.name === "Photon"
                                ? item.variants[item.variant].variant_name
                                : item.variants[item.variant].variantName);

                          const itemTotal =
                            isNewItemSchema && item.lineTotal !== undefined
                              ? item.lineTotal
                              : item.qty * item.price;

                          return (
                            <div
                              className="row  shipping-item-info mt-4 align-items-center"
                              key={item._id || item.variantId || itemIndex}
                            >
                              <div
                                className="col-4 p-2 "
                                style={{
                                  background: "#F4F5F7",
                                }}
                              >
                                {itemImage && (
                                  <img
                                    src={itemImage}
                                    className="img-fluid"
                                    alt=""
                                  />
                                )}
                              </div>
                              <div className="col-8 p-3 pt-0">
                                <div className="mb-3 item-name pb-2">
                                  <h5 className="fw-bold mb-0 color-dark">
                                    {item.name}{" "}
                                    {itemVariantName ? (
                                      <>
                                        <span>|</span>{" "}
                                        <span>{itemVariantName}</span>
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </h5>
                                </div>
                                <p className="fw-light mb-2 w-100 d-flex justify-content-between ">
                                  {" "}
                                  <span className="col-7">Color :</span>{" "}
                                  {itemColorName && (
                                    <span className="fw-bold col-5">
                                      {itemColorName}
                                    </span>
                                  )}
                                </p>
                                <p className="fw-light mb-2 w-100 d-flex justify-content-between ">
                                  {" "}
                                  <span className="col-7">Quantity :</span>{" "}
                                  <span className="fw-bold d-flex align-items-center justify-content-between  col-5">
                                    {" "}
                                    <span>{item.qty}</span>{" "}
                                  </span>
                                </p>
                                <p className="fw-light mb-0 w-100 d-flex justify-content-between ">
                                  {" "}
                                  <span className="col-7">Price :</span>{" "}
                                  <span className="fw-bold d-flex align-items-center justify-content-between  col-5">
                                    {" "}
                                    <span>{currencyFormat(itemTotal)}</span>{" "}
                                  </span>
                                </p>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderScreen;
